import React, { useEffect } from 'react'

const Pricing = () => {

    useEffect(() => {
        let current = 1;
        const fieldsets = document.querySelectorAll("fieldset");
        const steps = fieldsets.length;

        const setProgressBar = (curStep) => {
            const percent = (100 / steps) * curStep;
            const progressBar = document.querySelector(".progress-bar");
            if (progressBar) progressBar.style.width = percent + "%";
        };

        setProgressBar(current);

        const nextBtns = document.querySelectorAll(".next");
        const prevBtns = document.querySelectorAll(".previous");
        nextBtns.forEach((btn) => {
            const handleNext = () => {
                const current_fs = btn.parentElement;
                const next_fs = current_fs.nextElementSibling;
                const index = Array.from(fieldsets).indexOf(next_fs);
                document.querySelectorAll("#progressbar li")[index].classList.add("active");
                next_fs.style.display = "block";
                current_fs.style.transition = "opacity 0.4s ease";
                next_fs.style.transition = "opacity 0.4s ease";
                next_fs.style.opacity = "0";
                void next_fs.offsetHeight;
                current_fs.style.opacity = "0";
                next_fs.style.opacity = "1";
                setTimeout(() => {
                    current_fs.style.display = "none";
                }, 5);
                current++;
                setProgressBar(current);
            };
            btn.addEventListener("click", handleNext);
            btn.cleanup = () => btn.removeEventListener("click", handleNext);
        });
        prevBtns.forEach((btn) => {
            const handlePrev = () => {
                const current_fs = btn.parentElement;
                const previous_fs = current_fs.previousElementSibling;
                const index = Array.from(fieldsets).indexOf(current_fs);
                document.querySelectorAll("#progressbar li")[index].classList.remove("active");
                previous_fs.style.display = "block";
                current_fs.style.transition = "opacity 0.4s ease";
                previous_fs.style.transition = "opacity 0.4s ease";
                previous_fs.style.opacity = "0";
                void previous_fs.offsetHeight;
                current_fs.style.opacity = "0";
                previous_fs.style.opacity = "1";
                setTimeout(() => {
                    current_fs.style.display = "none";
                }, 5);
                current--;
                setProgressBar(current);
            };
            btn.addEventListener("click", handlePrev);
            btn.cleanup = () => btn.removeEventListener("click", handlePrev);
        });
        return () => {
            nextBtns.forEach((btn) => btn.cleanup && btn.cleanup());
            prevBtns.forEach((btn) => btn.cleanup && btn.cleanup());
        };
    }, []);

    return (
        <>
            <section className="main_slider">
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="inr_bnr_bg">
                                <img src="images/inrbnr.png" className="img-fluid" alt="..." />
                            </div>
                            <div className="carousel-caption">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className=" col-lg-6 col-md-8 col-sm-4 align-self-center">
                                            <div className="banner_text wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                                <h1>Payment Options</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="membership-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="section-heading">
                                <h2>Payment Options</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                                    labore et dolore magna aliqua.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-11 col-sm-10 col-md-10 col-lg-7 col-xl-7">
                            <div className="card">
                                <form id="msform">
                                    <ul id="progressbar">
                                        <li className="active" id="account"><strong>User Information</strong></li>
                                        <li id="personal"><strong>Select Tenure</strong></li>
                                        <li id="payment"><strong>Payment Method</strong></li>
                                    </ul>
                                    <div className="progress">
                                        <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuemin={0} aria-valuemax={100}>
                                        </div>
                                    </div>
                                    <fieldset>
                                        <div className="form-card">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <h2 className="fs-title">User Information</h2>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="grp_inp">
                                                        <label htmlFor>First Name</label>
                                                        <input type="text" name="fname" placeholder="Enter Your First Name" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="grp_inp">
                                                        <label htmlFor>Last Name</label>
                                                        <input type="text" name="lname" placeholder="Enter Your Last Name" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="grp_inp">
                                                        <label htmlFor>Email</label>
                                                        <input type="email" name="email" placeholder="Enter Your Email" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="grp_inp">
                                                        <label htmlFor>Phone Number</label>
                                                        <input type="number" name="number" placeholder="Enter Your Number" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="grp_inp">
                                                        <label htmlFor>Country</label>
                                                        <input type="text" name="text" placeholder="Enter Your Country" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="grp_inp">
                                                        <label htmlFor>State</label>
                                                        <input type="text" name="text" placeholder="Enter Your State" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="grp_inp">
                                                        <label htmlFor>City</label>
                                                        <input type="text" name="text" placeholder="Enter Your City" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="grp_inp">
                                                        <label htmlFor>Zip Code</label>
                                                        <input type="text" name="text" placeholder="Enter Your Zip Code" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <input type="button" name="next" className="next action-button" defaultValue="Next" />
                                    </fieldset>
                                    <fieldset>
                                        <div className="form-card">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <h2 className="fs-title">Select Tenure</h2>
                                                </div>
                                            </div>
                                            <div className="radio-input">
                                                <label className="label">
                                                    <input type="radio" id="value-1" name="value-radio" defaultValue="value-1" />
                                                    <p className="text">3 Months</p>
                                                    <span>Short Term</span>
                                                    <span>($100)</span>
                                                </label>
                                                <label className="label">
                                                    <input type="radio" id="value-2" name="value-radio" defaultValue="value-2" />
                                                    <p className="text">6 Months save 10%</p>
                                                    <span>Popular</span>
                                                    <span>($200)</span>
                                                </label>
                                                <label className="label">
                                                    <input type="radio" id="value-3" name="value-radio" defaultValue="value-3" />
                                                    <p className="text">12 Months save 25%</p>
                                                    <span>Best Value</span>
                                                    <span>($400)</span>
                                                </label>
                                            </div>
                                        </div>
                                        <input type="button" name="next" className="next action-button" defaultValue="Next" />
                                        <input type="button" name="previous" className="previous action-button-previous" defaultValue="Previous" />
                                    </fieldset>
                                    <fieldset>
                                        <div className="form-card">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <h2 className="fs-title">Select Payment Method</h2>
                                                </div>
                                            </div>
                                            <div className="radio-input">
                                                <label className="label">
                                                    <input type="radio" id="value1" name="value-radio1" defaultValue="One Time" />
                                                    <p className="text">One Time</p>
                                                </label>
                                                <label className="label">
                                                    <input type="radio" id="value2" name="value-radio1" defaultValue="Monthly" />
                                                    <p className="text">Monthly</p>
                                                </label>
                                                <label className="label">
                                                    <input type="radio" id="value3" name="value-radio1" defaultValue="Half Yearly" />
                                                    <p className="text">Half Yearly</p>
                                                </label>
                                                <label className="label">
                                                    <input type="radio" id="value4" name="value-radio1" defaultValue="Yearly" />
                                                    <p className="text">Yearly</p>
                                                </label>
                                            </div>
                                        </div>
                                        <input type="button" name="previous" className="action-button" defaultValue="Continue Payment" />
                                        <input type="button" name="previous" className="previous action-button-previous" defaultValue="Previous" />
                                    </fieldset>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}

export default Pricing